import { authPost, doPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

export function checkGroupCredit(params, isFastLink) {
  if (isFastLink) return doPost(`${baseUrl}/Agent1.ashx`, params);
  return authPost(`${baseUrl}/Agent1.ashx`, params);
}

export function postAgent21(params, isDefault) {
  return authPost(`${baseUrl}/Agent21.ashx`, params, undefined, isDefault);
}
